<template>
	<div ref="scroll">
		<!-- <el-breadcrumb separator-class="el-icon-arrow-right">
			<span class="iconfont" style="float: left;font-size: 14px;margin-right: 10px;">&#xe605;</span>
			<el-breadcrumb-item :to="{ path: '/home/index' }">主页</el-breadcrumb-item>
			<el-breadcrumb-item class="a">我的主页</el-breadcrumb-item>
		</el-breadcrumb> -->
		<!-- 轮播图 -->
		<div class="card" style="margin-top: -10px;">
			<div class="card-body">
				<el-carousel :interval="6000" arrow="always" trigger="click">
					<el-carousel-item v-for="item in adviceData">
						<el-row>
							<el-col :span="24">
								<img alt='' :src="item.images" style="width: 100%" />
							</el-col>
						</el-row>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>


		<div class="row">
			<div class="col-md-12">
				<div class="row">
					<div class="col-lg-4 col-md-12">
						<div class="card">
							<div class="card-body">
								<div class="d-flex justify-content-between mb-3" style="height: 67px !important;">
									<div>
										<p class="text-muted">便捷操作</p>
											<el-button size="mini" style="margin-right: 20px;" type="success" @click="order">下单</el-button>
												<router-link style="margin-right: 20px;" :to="{ path: '/order/receipt' }">
											<el-button size="mini" type="success">付款</el-button>
										</router-link>
										<router-link style="margin-right: 20px;" :to="{ path: '/assets/index' }">
											<el-button size="mini" type="primary">账户</el-button>
										</router-link>
									
									</div>
								<!-- 	<div>
										<figure class="avatar">
											<span class="avatar-title bg-success-bright text-success rounded-circle">
												<i class="ti-bar-chart"></i>
											</span>
										</figure>
									</div> -->
								</div>
								<div class="d-inline-flex align-items-center">
												<span class="text-success d-inline-flex align-items-center mr-2">
													<span></span> 本年订单金额：
												</span>￥{{ sum3 }}
			      </div>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-12">
						<div class="card">
							<div class="card-body">
								<div class="d-flex justify-content-between mb-3">
									<div>
										<p class="text-muted">待支付订单量</p>
										<a @click="goSell" href="#" style="cursor:pointer;">
											<h2 class="font-weight-bold">{{ records }}</h2>
										</a>
									</div>
									<div>
										<figure class="avatar">
											<span class="avatar-title bg-warning-bright text-warning rounded-circle">
												<i class="ti-reload"></i>
											</span>

										</figure>
									</div>
								</div>
								<div class="d-inline-flex align-items-center">
									<span class=" text-danger  d-inline-flex align-items-center mr-2">
										<span></span> 待支付金额：
									</span>￥{{ sum }}
								</div>
							</div>
						</div>
					</div>

					<div class="col-lg-4 col-md-12">
						<div class="card">
							<div class="card-body">
								<div class="d-flex justify-content-between mb-3">
									<div>
										<p class="text-muted">本月订单量</p>
										<a @click="goUnpaid" href="#" style="cursor:pointer;">
											<h2 class="font-weight-bold">{{ records2 }}</h2>
										</a>
									</div>
									<div>
										<figure class="avatar">
											<span class="avatar-title bg-info-bright text-info rounded-circle">
												<i class="ti-package"></i>
											</span>
										</figure>
									</div>
								</div>
								<div class="d-inline-flex align-items-center">
									<span class="text-info d-inline-flex align-items-center mr-2">
										<span></span> 本月订单金额：
									</span>￥{{ sum2 }}
								</div>
							</div>
						</div>
					</div>


				</div>
			</div>
		</div>

		<!-- 公告管理模块 -->
		<div class="row">
			<div class="col-lg-12 col-md-12">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between mb-3">
							<h6 class="card-title" style="font-size: 25px !important;">公告</h6>
							<a @click="gomore" href="#" style="cursor:pointer;">
								<h6 class="card-title" style="font-size: 25px !important;">更多</h6>
							</a>
						</div>
						<div>
							<ul class="list-group list-group-flush">

								<li v-for="item in news" class="list-group-item pl-0 pr-0">
									<!-- <a href="#" style="cursor:pointer;" @click="gonews(item['F_NewsId'])"> -->
									{{ item.F_NewsContent }}
									<span class="time">{{ item.F_ReleaseTime }}</span>
									<el-button @click="Download(item.fujian)" v-if="item.fujian!=null&&item.fujian!=''" type="text" size="medium">下载附件</el-button>


								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>


	</div>
</template>
<script>
	import echarts from 'echarts'
	import '@/font/iconfont.js'
	import request from '@/utils/request'

	export default {
		data() {
			return {
				news: [{
					F_NewsContent: "",
					F_ReleaseTime: "",
					fujian: ""
				}],
				adviceData: [{
						id: 1,
						body: "青春是一个短暂的美梦, 当你醒来时, 它早已消失无踪1",
						time: "2019-12-01",
						images: require('../../assets/image/home/1.jpg')
					},
					{
						id: 2,
						body: "青春是一个短暂的美梦, 当你醒来时, 它早已消失无踪2",
						time: "2019-12-02",
						images: require('../../assets/image/home/2.jpg')
					},
					{
						id: 3,
						body: "青春是一个短暂的美梦, 当你醒来时, 它早已消失无踪3",
						time: "2019-12-03",
						images: require('../../assets/image/home/3.jpg')
					},

				],
				pagination: {
					//默认每页显示的条数
					rows: 50,
					//默认显示第一页
					page: 1,
					//总数据条数
					records: 10,
					//总页数
					total: 5
				},
				//订单总数
				keyword: {
					F_Invalid: 0,
					// keyword: '',
					// F_Invalid: '',
					// F_FlowCode: '',
					// StartDate: '',
					// EndDate: ''
				},
				//待审核
				keyword2: {
					keyword: '',
					F_Invalid: 0,
					F_FlowCode: 'payed'
				},
				//待支付
				keyword3: {
					keyword: '',
					F_Invalid: 0,
					F_FlowCode: 'generate'
				},
				records: '',
				records2: '',
				records3: '',
				//top: [],
				sum: "0",
				sum2: "0",
				sum3: "0",
				// var myChart = echarts.init(document.getElementById('main'));
				// option: {
				//   noDataLoadingOption: {
				//     text: '暂无数据',
				//     effect: 'bubble',
				//     effectOption: {
				//       effect: {
				//         n: 0
				//       },
				//     }
				//   },
				//   title: {
				//     text: '奥华Top5销售报表'
				//   },
				//   tooltip: {},
				//   legend: {
				//     data: ['销量']
				//   },

				//   xAxis: {
				//     axisLabel: {
				//       interval: 0, //设置横坐标为斜
				//       // rotate: 30,//文字倾斜角度
				//       formatter: function (value) {
				//         var v = value.substring(0, 6) + '...'
				//         return value.length > 10 ? v : value
				//       }
				//     },
				//     data: []
				//   },
				//   yAxis: {},
				//   series: [{
				//     name: '销量',
				//     type: 'bar',
				//     data: []
				//   }]
				// },
				// option2: {
				//   title: {
				//     text: '奥华季度销售报表',
				//     subtext: '季度统计',
				//     left: 'center'
				//   },
				//   tooltip: {
				//     trigger: 'item',
				//     formatter: '{a} <br/>{b} : {c} ({d}%)'
				//   },
				//   legend: {
				//     orient: 'horizontal',
				//     left: 'center',
				//     top: '10%',
				//     data: ['第一季度', '第二季度', '第三季度', '第四季度']
				//   },
				//   series: [{
				//     name: '销售金额',
				//     type: 'pie',
				//     radius: '55%',
				//     center: ['50%', '60%'],
				//     data: [{
				//       value: 0,
				//       name: '第一季度'
				//     },
				//       {
				//         value: 0,
				//         name: '第二季度'
				//       },
				//       {
				//         value: 0,
				//         name: '第三季度'
				//       },
				//       {
				//         value: 0,
				//         name: '第四季度'
				//       }
				//     ],
				//     emphasis: {
				//       itemStyle: {
				//         shadowBlur: 10,
				//         shadowOffsetX: 0,
				//         shadowColor: 'rgba(0, 0, 0, 0.5)'
				//       }
				//     }
				//   }]
				// },
				// myChart :echarts.init(document.getElementById('main')),
				xAxisData: [],
				yAxisData: []

			}
		},
		created() {
			if (localStorage.getItem("login")) {
				this.$router.go(0)
				localStorage.removeItem("login")
			}
			this.getNew()
			this.getList()
			this.getList2()
			this.getList3()
			this.getTop()

			// location.reload()
		},
		// beforeMount() {
		//   this.$router.go(0)
		// },
		mounted() {
			// console.log(this.$refs)
		},
		methods: {

			// this.$router.go(0),
			//公告新闻
			getNew() {
				request({
					url: 'DRPAPI.ashx?a=getnews',
					methods: 'get',
					data: {
						pagination: JSON.stringify({
							rows: 5,
							page: 1
						}),
						keyword: ''
					},
				}).then(res => {
					this.news = res.data.rows
				})
			},
			//附件下载
			Download(fujian) {
				var url = 'http://36.22.191.66:4005/' + fujian
				var a = document.createElement('a')
				a.setAttribute('href', url)
				a.setAttribute('target', '_blank')
				// a.href = url
				a.click()

			},
			order(){
				this.$router.push({
				  name: '订单管理',
				  params: {
				    ids: "",
				    value:"",
				    proValue:"",
				  }
				})
			},
			//新闻详情跳转
			gonews(id) {

				this.$router.push('/home/journalism?ids=' + id)
			},
			//更多点击跳转
			gomore() {
				this.$router.push('/home/morenews')
			},
			//销售数据卡片跳转
			goSell() {
				this.$router.push('/order/promote22232')
			},
			//待支付卡片跳转
			goUnpaid() {
				//this.$router.push('/order/promote22232')
			},
			//待审核卡片跳转
			goCheck() {
				//this.$router.push('/order/promote22232')
			},
			//跳转至详情页面
			handleProductClick(id) {
				this.$router.push({
					path: '/procure/product/detail',
					query: {
						id: id
					}
				})
			},
			//获取销售数据
			//全部
			getList() {
				request({
					url: 'DRPAPI.ashx?a=getorderlist',
					method: 'get'

				}).then(res => {
					this.records = res.data.records;
					this.sum = res.data.sum;
					this.records2 = res.data.records2;
					this.sum2 = res.data.sum2;
					this.records3 = res.data.records3;
					this.sum3 = res.data.sum3;

					// //扇形图
					// var myChart2 = echarts.init(document.getElementById('main2'));
					// var option2 = this.option2;
					// myChart2.setOption(option2);
					// res.data.rows.forEach(item => {
					//   let month = Number(item.F_CreateDate.substring(5, 7));
					//   let time = (item.F_CreateDate.substring(0, 4));
					//   //第一季度
					//   if (time === time && (month === 1 || month === 2 || month === 3)) {
					//     var onesum = 0
					//     onesum += item.F_OrderAmount
					//   }
					//   if (onesum) {
					//     this.option2.series[0].data[0].value += onesum;
					//     myChart2.setOption(option2);
					//   }
					//   //第二季度
					//   if (time === time && (month === 4 || month === 5 || month === 6)) {
					//     var twosum = 0
					//     twosum += item.F_OrderAmount
					//   }
					//   if (twosum) {
					//     this.option2.series[0].data[1].value += twosum;
					//     myChart2.setOption(option2);
					//   }
					//   //第三季度
					//   if (time === time && (month === 7 || month === 8 || month === 9)) {
					//     var threesum = 0
					//     threesum += item.F_OrderAmount
					//   }
					//   if (threesum) {
					//     this.option2.series[0].data[2].value += threesum;
					//     myChart2.setOption(option2);
					//   }
					//   //第四季度
					//   if (time === time && (month === 10 || month === 11 || month === 12)) {
					//     var foursum = 0
					//     foursum += item.F_OrderAmount
					//   }
					//   if (foursum) {
					//     this.option2.series[0].data[3].value += foursum;
					//     myChart2.setOption(option2);
					//   }

					// })
				})
			},
			//待审核
			getList2() {
				// request({
				//   url: 'DRPAPI.ashx?a=getorderlist',
				//   method: 'get',
				//   data: {
				//     pagination: JSON.stringify(this.pagination),
				//     queryJson: JSON.stringify(this.keyword2)
				//   }
				// }).then(res => {
				//   this.records2 = res.data.records
				//   var sum2 = 0
				//   for (var i = 0; i < res.data.rows.length; i++) {
				//     sum2 += res.data.rows[i].F_OrderAmount
				//   }
				//   this.sum2 = sum2.toFixed(2)
				// })
			},
			//待支付
			getList3() {
				// request({
				//   url: 'DRPAPI.ashx?a=getorderlist',
				//   method: 'get',
				//   data: {
				//     pagination: JSON.stringify(this.pagination),
				//     queryJson: JSON.stringify(
				//         this.keyword3
				//     )
				//   }
				// }).then(res => {
				//   this.records3 = res.data.records
				//   var sum3 = 0
				//   for (var i = 0; i < res.data.rows.length; i++) {
				//     sum3 += res.data.rows[i].F_OrderAmount
				//   }
				//   this.sum3 = sum3.toFixed(2)
				// })
			},
			//推荐商品top5
			getTop() {
				// request({
				//   url: 'DRPAPI.ashx?a=getproduct',
				//   method: 'get',
				// }).then(res => {
				//   res.data.rows.forEach(item => {
				//     if (item !== null && item !== '' && item.product !== null) {
				//       this.top = res.data.rows
				//       var myChart = echarts.init(document.getElementById('main'));
				//       var option = this.option;
				//       // //柱状图
				//       // var xAxis = 0
				//       // var seriess = 0
				//       // // for (var i = 0; i < res.data.rows.length; i++) {
				//       // //   xAxis = res.data.rows[i].product.F_ClassName;
				//       // //   this.option.xAxis.data.push(xAxis)
				//       // //   seriess = res.data.rows[i].F_Quantity
				//       // //   this.option.series[0].data.push(parseInt(seriess))
				//       // // }
				//       // xAxis = item.product.F_ClassName;
				//       // this.option.xAxis.data.push(xAxis)
				//       // seriess = item.F_Quantity
				//       // this.option.series[0].data.push(parseInt(seriess))
				//       // myChart.setOption(option);
				//     }

				//   })


				// })
			},
		}
	}
</script>

<style scoped>
	@import "../../font/iconfont.css";

	@font-face {
		font-family: 'iconfont';
		src: url('../../font/iconfont.eot');
		src: url('../../font/iconfont.eot?#iefix') format('embedded-opentype'),
			url('../../font/iconfont.woff2') format('woff2'),
			url('../../font/iconfont.woff') format('woff'),
			url('../../font/iconfont.ttf') format('truetype'),
			url('../../font/iconfont.svg#iconfont') format('svg');
	}

	.iconfont {
		font-family: "iconfont" !important;
		font-size: 12px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.more {
		float: right;
		font-weight: 700;
	}

	.time {
		float: right;
	}

	.a .el-breadcrumb__inner {
		color: #0081ff !important;
		font-weight: 700 !important;
	}

	.img {
		width: 25px;
		height: 25px;
	}
</style>
